import React from "react";
import {Tag as ChakraTag, TagRootProps, Spinner} from "@chakra-ui/react";

export type TagButtonProps = {
  loading?: boolean;
  disabled?: boolean;
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
} & TagRootProps;

const TagButton = React.forwardRef<HTMLButtonElement, TagButtonProps>(
  ({children, colorPalette, loading, size = "xl", startElement, endElement, disabled, ...props}, ref) => {
    return (
      <ChakraTag.Root
        asChild
        size={size}
        rounded="full"
        _hover={{bg: `${colorPalette}.200`}}
        position="relative"
        ref={ref}
        colorPalette={colorPalette}
        cursor={disabled ? "default" : "pointer"}
        overflow="hidden"
        whiteSpace="nowrap"
        {...props}
      >
        <button disabled={disabled} onClick={e => e.stopPropagation()}>
          {loading || startElement ? (
            <ChakraTag.StartElement>
              {loading ? <Spinner color={`${colorPalette}.500`} size="sm" /> : startElement}
            </ChakraTag.StartElement>
          ) : null}
          <ChakraTag.Label>{children}</ChakraTag.Label>
          {endElement && <ChakraTag.EndElement>{endElement}</ChakraTag.EndElement>}
        </button>
      </ChakraTag.Root>
    );
  },
);

export default TagButton;
